export default "__VITE_ASSET__A2mGstDl__"